/** 最后一层客户端兜底：旧服务或代理即使返回技术异常，也不能把代码展示给用户。 */
export function safeUserMessage(message: string): string {
  if (
    /^(?:failed to fetch|fetch failed|network ?error(?: when attempting to fetch resource\.?)?|load failed|network request failed)$/i.test(
      message.trim()
    )
  ) {
    return '暂时无法连接服务，请检查网络后重试';
  }
  const technical =
    /^\s*[[{]/.test(message) ||
    /(invalid_(?:type|format)|zod|regex|regexp|stack trace|prisma|sqlstate|node:internal|\bat\s+async\b|"path"\s*:|"origin"\s*:)/i.test(
      message
    );
  if (technical) {
    return '填写内容格式不正确，请检查后重试';
  }
  return message || '操作未完成，请稍后重试';
}
